import { ClickAwayListener } from '@material-ui/core';
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { LoadingPanel } from '../loading/Loading';
import { Button } from './Button';

interface IProps {
    label: string;
    listItems: IGroupOption[];
    onItemSelected: any;
    isDisabled: boolean;
    testID: string;
}

interface IGroupOption {
    id: number;
    display: string;
}

export const PopoverButton = (props : IProps) => {

    const [showGroupPopover, setShowGroupPopover] = React.useState(false);

    const openButtonPopover = () => {
        setShowGroupPopover(true);
    };

    const dismissPopover = () => {
        setShowGroupPopover(false);
    };

    return <ClickAwayListener onClickAway={ dismissPopover }>
                <div className="popover-button-wrapper">
                    <Button
                        text={ props.label }
                        icon="la-arrows-v"
                        testID={ props.testID }
                        disable={ props.isDisabled }
                        onBtnClick={ openButtonPopover } />
                    <CSSTransition
                        in={ showGroupPopover }
                        timeout={300}
                        classNames="productionOrderMenu"
                        unmountOnExit>
                        <div className="action-bar-popover">
                        {
                            props.listItems.length > 0
                                ? <div className="action-bar-popover-list">
                                    <ul>
                                    {
                                        props.listItems.map((itm: any) =>
                                            <li 
                                                onClick={() => props.onItemSelected(itm.id)}
                                                key={itm.id}>
                                                {itm.display}
                                                <i className="la la-plus-circle" />
                                            </li>
                                        )
                                    }
                                    </ul>
                                </div>
                                : <LoadingPanel mini={true} />
                        }
                        </div>
                    </CSSTransition>
                </div>
            </ClickAwayListener>;
};
